export const GET_REPORT_DATA = 'GET_REPORT_DATA';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const GET_REPORT_DATA_BY_YEAR = 'GET_REPORT_DATA_BY_YEAR';
export const SET_REPORT_DATA_BY_YEAR = 'SET_REPORT_DATA_BY_YEAR';
export const GET_SPEND_REBATE_DASHBOARD = 'GET_SPEND_REBATE_DASHBOARD'
export const SET_SPEND_REBATE_DASHBOARD = 'SET_SPEND_REBATE_DASHBOARD'
export const GET_MANUFACTURER_REPORT_DATA = 'GET_MANUFACTURER_REPORT_DATA';
export const SET_MANUFACTURER_REPORT_DATA = 'SET_MANUFACTURER_REPORT_DATA';
export const GET_ACCOUNTANDFINANCE_REPORT = 'GET_ACCOUNTANDFINANCE_REPORT';
export const SET_ACCOUNTANDFINANCE_REPORT = 'SET_ACCOUNTANDFINANCE_REPORT';